import { ValidationIcon_default } from "./chunk-N7RSLTZJ.js";
import { InputComponent } from "./chunk-DBD5CSY6.js";
import { Spinner_default } from "./chunk-3P5HEDZF.js";
import { renderIcon } from "./chunk-6KW5RJ5F.js";
import { __objRest, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/elements/TextInput/TextInput.tsx
import { forwardRef, useMemo, useRef, useImperativeHandle } from "react";
import clsx from "clsx";
import { jsx, jsxs } from "react/jsx-runtime";
var TEXT_INPUT_CLASSNAME_MAP = {};
var TextInput = forwardRef((_a, ref) => {
  var _b = _a,
    {
      variant = "secondary",
      suffix,
      iconBefore: iconBeforeProp,
      iconAfter: iconAfterProp,
      disabled,
      validation,
      isLoading,
      className,
      onClick
    } = _b,
    rest = __objRest(_b, ["variant", "suffix", "iconBefore", "iconAfter", "disabled", "validation", "isLoading", "className", "onClick"]);
  const inputRef = useRef(null);
  const iconBefore = useMemo(() => iconBeforeProp && renderIcon(iconBeforeProp), [iconBeforeProp]);
  const iconAfter = useMemo(() => iconAfterProp && renderIcon(iconAfterProp), [iconAfterProp]);
  useImperativeHandle(ref, () => inputRef.current);
  const handleClick = () => {
    var _a2;
    (_a2 = inputRef.current) == null ? void 0 : _a2.focus();
  };
  const handleInputClick = event => {
    event.stopPropagation();
    onClick == null ? void 0 : onClick(event);
  };
  return /* @__PURE__ */jsxs(InputComponent, {
    variant,
    validation: variant === "secondary" ? validation : void 0,
    disabled,
    className: clsx("pd:text-input", className),
    onClick: handleClick,
    children: [iconBefore && /* @__PURE__ */jsx(InputComponent.Icon, {
      children: iconBefore
    }), /* @__PURE__ */jsx(InputComponent.Input, __spreadValues({
      ref: inputRef,
      isLoading,
      onClick: handleInputClick
    }, rest)), suffix && /* @__PURE__ */jsx("span", {
      className: "pd:shrink-0 pd:text-dim-600",
      children: suffix
    }), iconAfter && /* @__PURE__ */jsx(InputComponent.Icon, {
      children: iconAfter
    }), variant === "secondary" && validation && !isLoading && /* @__PURE__ */jsx(InputComponent.Icon, {
      children: /* @__PURE__ */jsx(ValidationIcon_default, {
        variant: validation
      })
    }), isLoading && /* @__PURE__ */jsx(InputComponent.Icon, {
      children: /* @__PURE__ */jsx(Spinner_default, {
        variant: "primary"
      })
    })]
  });
});
var TextInput_default = TextInput;
export { TEXT_INPUT_CLASSNAME_MAP, TextInput_default };